import { render } from "./CutPaste.vue?vue&type=template&id=44f29dda"
import script from "./CutPaste.vue?vue&type=script&lang=js"
export * from "./CutPaste.vue?vue&type=script&lang=js"
script.render = render

export default script